"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Hitagi_Plugin_Room {
    constructor(HitagiInstance) {
        this.OnListEvents = [];
        this.OnErrorEvents = [];
        this.OnMessageEvents = [];
        this.Clients = {};
        this.hitagi = HitagiInstance;
    }
    //====================================================================
    // Plugin Room API
    //====================================================================
    create_room(RoomId, RoomPassword, Success, Error) {
        const Packet = {
            "plugin": "room",
            "action": "create_room",
            "args": { "roomid": RoomId, "roompassword": RoomPassword }
        };
        this.hitagi.send(Packet, Success, Error);
    }
    destroy_room(RoomId, Success, Error) {
        this.hitagi.action("room", "destroy_room", { "roomid": RoomId }, Success, Error);
    }
    switch_room(RoomId, RoomPassword, Success, Error) {
        this.hitagi.action("room", "switch_room", { "roomid": RoomId, "roompassword": RoomPassword }, Success, Error);
    }
    join_room(RoomId, RoomPassword, Success, Error) {
        this.hitagi.action("room", "join_room", { "roomid": RoomId, "roompassword": RoomPassword }, Success, Error);
    }
    leave_room(RoomId, Success, Error) {
        this.hitagi.action("room", "leave_room", { "roomid": RoomId }, Success, Error);
    }
    //====================================================================
    // Plugin Room server callbacks
    //====================================================================
    callback__list(Data) {
        this.hitagi.fire_event("chat:list", Data);
    }
    callback__service_message(Args) {
        this.hitagi.fire_event("service_message", Args);
    }
    callback__message(Message) {
        this.hitagi.call_event(this.OnMessageEvents, Message);
    }
    callback__room_destroyed(Args) {
        this.hitagi.fire_event("room_destroyed", Args);
    }
    callback__room_updated(Args) {
        this.hitagi.fire_event("room:room_updated", Args);
    }
    callback__rooms_list(Args) {
        this.hitagi.fire_event("rooms_list", Args);
    }
    callback__client_login(Args) {
        //Hitagi.room.Clients[Args["ufrag"]] = Args;
        this.hitagi.fire_event("room:client_login", Args);
    }
    callback__client_logout(Args) {
        //delete Hitagi.room.Clients[Args["ufrag"]];
        this.hitagi.fire_event("room:client_logout", Args);
    }
    callback__client_update(Args) {
        //Hitagi.room.Clients[Args["ufrag"]] = Args;
        this.hitagi.fire_event("room:client_update", Args);
    }
    callback__subscription_payment_failed(Args) {
        this.hitagi.fire_event("room:subscription_payment_failed", Args);
    }
}
exports.default = Hitagi_Plugin_Room;
